'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureGoogleAnalitycs;

var _scriptLoader = require('./script-loader.js');

var _scriptLoader2 = _interopRequireDefault(_scriptLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureGoogleAnalitycs(_ref) {
  var config = _ref.config,
      handlers = _ref.handlers,
      window = _ref.window,
      document = _ref.document;

  var promise = Promise.resolve();

  if (config.preloaded) {
    var src = 'https://www.google-analytics.com/analytics.js';
    var stub = function stub() {
      stub.q.push(arguments);
    };
    stub.q = [];
    stub.l = 1 * new Date();
    window.GoogleAnalyticsObject = 'ga';

    promise = (0, _scriptLoader2.default)({ src: src, globalName: 'ga', stub: stub, window: window, document: document });
    window.ga('create', config.id, 'auto');
  }

  handlers.push(handleEvent);

  return promise;

  function handleEvent(_ref2) {
    var type = _ref2.type,
        eventAction = _ref2.id,
        properties = _ref2.properties,
        label = _ref2.label,
        userId = _ref2.userId;

    var location = window.location || {};
    if (type === 'page') {
      return window.ga('send', 'pageview', {
        page: '' + location.pathname + location.search + location.hash
      });
    }

    if (type === 'track') {
      var gaEvent = {
        hitType: 'event',
        eventCategory: properties.category || 'All',
        eventAction: eventAction,
        eventLabel: properties.label || label
      };
      return window.ga('send', gaEvent);
    }

    if (type === 'setUserId' && userId) {
      return window.ga('set', 'userId', userId);
    }

    return null;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/auth0-tag-manager/lib/google-analytics.js
// module id = 7
// module chunks = 0